import React from "react";
import EvaList from "modules/eva/containers/EvaList";

const EvaListPage: React.FC = () => {
  return <EvaList />;
};

export default EvaListPage;
